import React, { useState, useEffect } from 'react';

import createStyle from 'shared-utils/src/createStyle';

import styles, { mainCls } from './style';
import makeClassName from 'shared-utils/src/makeClassName';

const useStyles = createStyle(styles);

export default function Tooltip({ text, revealed, hidden, topCoords, classNameBaloon }) {
  const cls = useStyles();

  const [toState, setToState] = useState(null);
  const [isRevealed, setIsRevealed] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  
  const tooltipCls = makeClassName([
    cls[mainCls],
    'p--s tp-s--xs tp-w--m tp-a--c c-txt--w c-bg--f2', 
    isRevealed ? ' revealed' : '',
    isHidden ? ' hidden' : '',
    classNameBaloon ? `${cls[`${mainCls}__${classNameBaloon}`]}` : '',
  ]);

  useEffect(() => {
    if (revealed) {
      clearTimeout(toState);      
      setIsHidden(false);
      setIsRevealed(true);
    } else if (hidden) {
      setIsHidden(true);
      const to = setTimeout(() => {
        setIsRevealed(false);
        setIsHidden(false);
      }, 501);
      setToState(to);
    }
  }, [revealed, hidden]);

  return (
    <div 
      style={{ top: topCoords }}
      className={tooltipCls}
    >
      {text}
    </div>
  );
}